import { FinanceRate } from '@kanda-libs/ks-frontend-services';

export const PLACEHOLDER_RATES: FinanceRate[] = [
  {
    name: 'placeholder1',
    charge: 0,
    fee: 0,
    enabled: true,
    finance_types: ['primary'],
    provider: 'demo',
    apr: 0,
    apr_type: 'INTEREST_FREE',
    duration: 10,
  },
  {
    name: 'placeholder2',
    charge: 0,
    fee: 0,
    enabled: true,
    finance_types: ['primary'],
    provider: 'demo',
    apr: 1490,
    apr_type: 'INTEREST_BEARING',
    duration: 60,
  },
  {
    name: 'placeholder3',
    charge: 0,
    fee: 0,
    enabled: true,
    finance_types: ['primary'],
    provider: 'demo',
    apr: 1490,
    apr_type: 'BUYNOW_PAYLATER',
    duration: 60,
  },
];
